export const PRICING_HEADING_CONSTANTS = {
  title: "Our Storage Resources Pricing",
  object_storage: "Object Storage",
  block_storage: "Block Storage",
};
